(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chiko-accessibility"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('[data-chiko-a11y]');
    if (!root) return;

    var html = document.documentElement;
    var toggle = root.querySelector('[data-a11y-toggle]');
    var panel = root.querySelector('[data-a11y-panel]');
    var note = root.querySelector('[data-a11y-note]');
    var live = root.querySelector('[data-a11y-live]');
    var steps = root.querySelectorAll('[data-a11y-text]');
    var tiles = root.querySelectorAll('[data-a11y-flag]');
    var KEY = 'chiko-a11y';
    var FLAGS = ['contrast', 'links', 'font', 'spacing', 'focus', 'still'];
    var SCALES = [1, 1.15, 1.3];
    var focusable = 'button:not([disabled]), [href], input:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var state = read();
    var held = [];
    var hideTimer = null;
    var resizeTimer = null;
    var liveTimer = null;

    function blank() {
      var value = { text: 0 };
      FLAGS.forEach(function (name) { value[name] = false; });
      return value;
    }

    function read() {
      var value = blank();
      try {
        var saved = JSON.parse(localStorage.getItem(KEY));
        if (saved && typeof saved === 'object') {
          if (saved.text === 1 || saved.text === 2) value.text = saved.text;
          FLAGS.forEach(function (name) { value[name] = saved[name] === true; });
        }
      } catch (error) {}
      return value;
    }

    function save() {
      try {
        var empty = !state.text && FLAGS.every(function (name) { return !state[name]; });
        if (empty) localStorage.removeItem(KEY);
        else localStorage.setItem(KEY, JSON.stringify(state));
      } catch (error) {}
    }

    function storable() {
      try {
        localStorage.setItem(KEY + '-test', '1');
        localStorage.removeItem(KEY + '-test');
        return true;
      } catch (error) {
        return false;
      }
    }

    function scaleText() {
      html.style.removeProperty('font-size');
      html.style.removeProperty('--chiko-text-scale');
      html.classList.remove('chiko-a11y-text-1', 'chiko-a11y-text-2');
      if (!state.text) return;
      var base = parseFloat(getComputedStyle(html).fontSize) || 16;
      html.style.setProperty('font-size', (base * SCALES[state.text]).toFixed(2) + 'px');
      html.style.setProperty('--chiko-text-scale', String(SCALES[state.text]));
      html.classList.add('chiko-a11y-text-' + state.text);
    }

    function decorative(video) {
      return video.muted && !video.controls;
    }

    function play(video) {
      try {
        var started = video.play();
        if (started && started.catch) started.catch(function () {});
      } catch (error) {}
    }

    function holdVideos() {
      if (state.still) {
        document.querySelectorAll('video').forEach(function (video) {
          if (decorative(video) && !video.paused) {
            video.pause();
            if (held.indexOf(video) < 0) held.push(video);
          }
        });
      } else {
        held.forEach(play);
        held = [];
      }
    }

    function render() {
      scaleText();
      FLAGS.forEach(function (name) { html.classList.toggle('chiko-a11y-' + name, state[name]); });
      holdVideos();
      steps.forEach(function (step) {
        step.setAttribute('aria-pressed', String(Number(step.getAttribute('data-a11y-text')) === state.text));
      });
      tiles.forEach(function (tile) {
        tile.setAttribute('aria-pressed', String(state[tile.getAttribute('data-a11y-flag')]));
      });
      var detail = { text: state.text };
      FLAGS.forEach(function (name) { detail[name] = state[name]; });
      document.dispatchEvent(new CustomEvent('chiko:a11y', { detail: detail }));
    }

    function announce(message) {
      clearTimeout(liveTimer);
      live.textContent = '';
      liveTimer = setTimeout(function () {
        live.textContent = message;
        liveTimer = setTimeout(function () { live.textContent = ''; }, 4000);
      }, 60);
    }

    // Another button can open the panel too, like the a11y circle on the theme's sticky buy bar: it carries
    // data-a11y-opener, counts as part of the widget, and gets the focus back when the panel closes.
    var opener = null;

    function ours(target) {
      return root.contains(target) || !!(target.closest && target.closest('[data-a11y-opener]'));
    }

    function setOpeners(value) {
      Array.prototype.forEach.call(document.querySelectorAll('[data-a11y-opener]'), function (el) {
        el.setAttribute('aria-expanded', value);
      });
    }

    function isOpen() {
      return toggle.getAttribute('aria-expanded') === 'true';
    }

    function outside(event) {
      if (!ours(event.target)) close(false);
    }

    function away(event) {
      if (!ours(event.target)) close(false);
    }

    function keys(event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        event.preventDefault();
        event.stopPropagation();
        close(true);
        return;
      }
      if (event.key !== 'Tab') return;
      var items = Array.prototype.filter.call(panel.querySelectorAll(focusable), function (el) {
        return el.getClientRects().length > 0;
      });
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      var at = document.activeElement;
      var inside = at !== panel && panel.contains(at);
      if (event.shiftKey ? !inside || at === first : !inside || at === last) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
      }
    }

    function open() {
      clearTimeout(hideTimer);
      root.classList.add('is-open');
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      setOpeners('true');
      void panel.offsetWidth;
      panel.classList.add('is-in');
      var first = panel.querySelector('[data-a11y-text][aria-pressed="true"]') || panel.querySelector(focusable);
      if (first) first.focus({ preventScroll: true });
      document.addEventListener('click', outside, true);
      document.addEventListener('keydown', keys, true);
      document.addEventListener('focusin', away);
    }

    function close(restore) {
      if (!isOpen()) return;
      panel.classList.remove('is-in');
      toggle.setAttribute('aria-expanded', 'false');
      setOpeners('false');
      document.removeEventListener('click', outside, true);
      document.removeEventListener('keydown', keys, true);
      document.removeEventListener('focusin', away);
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () {
        panel.hidden = true;
        root.classList.remove('is-open');
      }, 280);
      if (restore) {
        var back = opener && document.contains(opener) && opener.getClientRects().length && getComputedStyle(opener).visibility !== 'hidden' ? opener : toggle;
        back.focus({ preventScroll: true });
      }
      opener = null;
    }

    toggle.addEventListener('click', function () {
      if (isOpen()) close(true);
      else { opener = toggle; open(); }
    });

    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('[data-a11y-opener]');
      if (!button) return;
      event.preventDefault();
      if (isOpen()) close(true);
      else { opener = button; open(); }
    });

    panel.addEventListener('click', function (event) {
      var target = event.target.closest('[data-a11y-text], [data-a11y-flag], [data-a11y-reset], [data-a11y-close]');
      if (!target) return;
      if (target.hasAttribute('data-a11y-close')) {
        close(true);
        return;
      }
      if (target.hasAttribute('data-a11y-text')) {
        state.text = Number(target.getAttribute('data-a11y-text')) || 0;
      } else if (target.hasAttribute('data-a11y-flag')) {
        var name = target.getAttribute('data-a11y-flag');
        state[name] = !state[name];
      } else {
        state = blank();
        announce('ההגדרות אופסו');
      }
      save();
      render();
    });

    document.addEventListener('play', function (event) {
      var video = event.target;
      if (state.still && video instanceof HTMLVideoElement && decorative(video)) {
        video.pause();
        if (held.indexOf(video) < 0) held.push(video);
      }
    }, true);

    window.addEventListener('resize', function () {
      if (!state.text) return;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(scaleText, 150);
    });

    if (note && !storable()) note.textContent = 'ההגדרות יחולו רק בעמוד הזה';
    render();
    toggle.hidden = false;
    toggle.classList.add('is-ready');
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["chiko-cookie-consent"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('[data-chiko-cc]');
    if (!root) return;

    var banner = root.querySelector('.chiko-cc__banner');
    var card = root.querySelector('.chiko-cc__card');
    var overlay = root.querySelector('.chiko-cc__overlay');
    var panel = root.querySelector('.chiko-cc__prefs');
    var switches = root.querySelectorAll('[data-cc-purpose]');
    var focusable = 'button:not([disabled]), [href], input:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var privacy = null;
    var opener = null;
    var sizer = null;

    function withPrivacy(done) {
      if (privacy) return done(privacy);
      var shopify = window.Shopify;
      if (shopify && shopify.customerPrivacy) {
        privacy = shopify.customerPrivacy;
        return done(privacy);
      }
      if (!shopify || typeof shopify.loadFeatures !== 'function') return;
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], function (error) {
        if (error || !window.Shopify.customerPrivacy) return;
        privacy = window.Shopify.customerPrivacy;
        done(privacy);
      });
    }

    function nextFrame(callback) {
      requestAnimationFrame(function () { requestAnimationFrame(callback); });
    }

    function measure() {
      if (!document.documentElement.classList.contains('chiko-cookies-open')) return;
      document.documentElement.style.setProperty('--chiko-cookies-h', card.offsetHeight + 'px');
    }

    // The snippet renders near the end of the page, so Tab reached the banner only after the whole page
    // and the reviews widget (31.10 audit: Tab 103). Opening it moves it to the top of <body>.
    function show() {
      if (document.body.firstElementChild !== root) document.body.insertBefore(root, document.body.firstChild);
      banner.hidden = false;
      document.documentElement.classList.add('chiko-cookies-open');
      measure();
      if (window.ResizeObserver) {
        sizer = sizer || new ResizeObserver(measure);
        sizer.observe(card);
      }
      nextFrame(function () { banner.classList.add('is-in'); });
    }

    // A choice made with the keyboard hands focus to the skip link, not to <body> (31.10 audit).
    function hide(byKey) {
      if (byKey) {
        var next = document.querySelector('.skip-to-content-link') || document.querySelector('main');
        if (next) next.focus({ preventScroll: true });
      }
      banner.classList.remove('is-in');
      document.documentElement.classList.remove('chiko-cookies-open');
      document.documentElement.style.removeProperty('--chiko-cookies-h');
      if (sizer) sizer.disconnect();
      setTimeout(function () { banner.hidden = true; }, 360);
    }

    function openPrefs(from) {
      withPrivacy(function (api) {
        opener = from || document.activeElement;
        var current = api.currentVisitorConsent ? api.currentVisitorConsent() : {};
        switches.forEach(function (box) {
          box.checked = current[box.getAttribute('data-cc-purpose')] === 'yes';
        });
        overlay.hidden = false;
        nextFrame(function () { overlay.classList.add('is-in'); });
        var first = panel.querySelector('[data-cc-purpose]');
        if (first) first.focus({ preventScroll: true });
      });
    }

    function closePrefs() {
      overlay.classList.remove('is-in');
      setTimeout(function () { overlay.hidden = true; }, 260);
      if (opener && document.contains(opener)) opener.focus({ preventScroll: true });
    }

    function save(consent, byKey) {
      withPrivacy(function (api) {
        api.setTrackingConsent(consent, function () {
          if (!overlay.hidden) closePrefs();
          if (!banner.hidden) hide(byKey);
        });
      });
    }

    function all(value) {
      return { analytics: value, marketing: value, preferences: value };
    }

    root.addEventListener('click', function (event) {
      var target = event.target.closest('[data-cc-accept], [data-cc-decline], [data-cc-open], [data-cc-close], [data-cc-save], [data-cc-all]');
      if (!target) {
        if (event.target === overlay) closePrefs();
        return;
      }
      // A click that Enter or Space made has detail 0.
      var byKey = event.detail === 0;
      if (target.hasAttribute('data-cc-accept') || target.hasAttribute('data-cc-all')) {
        save(all(true), byKey);
      } else if (target.hasAttribute('data-cc-decline')) {
        save(all(false), byKey);
      } else if (target.hasAttribute('data-cc-open')) {
        openPrefs(target);
      } else if (target.hasAttribute('data-cc-close')) {
        closePrefs();
      } else if (target.hasAttribute('data-cc-save')) {
        var chosen = all(false);
        switches.forEach(function (box) {
          chosen[box.getAttribute('data-cc-purpose')] = box.checked;
        });
        save(chosen, byKey);
      }
    });

    root.addEventListener('keydown', function (event) {
      if (overlay.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closePrefs();
        return;
      }
      if (event.key !== 'Tab') return;
      var items = Array.prototype.filter.call(panel.querySelectorAll(focusable), function (el) {
        return el.offsetParent !== null;
      });
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    document.addEventListener('click', function (event) {
      var manage = event.target.closest('[data-chiko-cookies-open]');
      if (!manage) return;
      event.preventDefault();
      openPrefs(manage);
    });

    // shouldShowBanner() only says the region needs a banner; it stays true after the visitor chose,
    // so the banner also waits for a purpose that is still "" (31.10: it came back on every page).
    function undecided(api) {
      var current = api.currentVisitorConsent ? api.currentVisitorConsent() : {};
      return !['analytics', 'marketing', 'preferences'].some(function (purpose) {
        return current[purpose] === 'yes' || current[purpose] === 'no';
      });
    }

    withPrivacy(function (api) {
      if (api.shouldShowBanner() && undecided(api)) show();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
